<template>
    <div class="contact-us full-screen">
        <!-- content v-if="checkMsgWhoAmi('staff') || checkMsgWhoAmi('faculty')"  -->
        <!-- token : {{ getTokenUrl }} -->
        <div class="wrapper wrapper-full-page section content bg-image">
            <div>
                <div class="container mb-3">
                    <div class="text-center d-sm-flex justify-content-between align-items-center">
                        <img class="mb-2 mt-5" src="@/assets/img/election_logo.png" alt="MUIC">
                        <div class="text-right">
                            <h6 class="mt-2"><i class="fa fa-user-circle-o"></i> {{ $keycloak.fullName }}</h6>
                            <a class="font-thai" :href="$keycloak.createLogoutUrl()"><i class="fa fa-sign-out"></i>Log out</a>
                        </div>
                    </div>
                    <hr>
                    <div class="text-center">
                        <small style="font-size:1.2rem;" class="font-thai-1 text-danger">{{ moment().locale('th').format('LL') }} {{ currentTime }}</small>
                    </div>
                    <!-- select Team -->
                    <!-- {{ row.rowSelected }} -->
                    <!-- <span aria-hidden="true">&check;</span> -->
                    
                    <!-- for event -->
                    <!-- <h5 class="font-thai-1 mt-3 mb-1" style="color:#3c1944;">{{ nameEvent }}</h5> -->
                    
                    <p class="font-thai-1 mt-0 mb-2" v-html="alertMsgDetail"></p>
                    <!-- <p v-if="nameEvent !== ''" class="font-thai-1 mt-1 mb-1"><i class="fa fa-calendar mr-2"></i>{{ startDate }} - {{ endDate }}</p> -->
                    <div v-if="nameEvent !== ''" class="d-flex justify-content-between align-items-center">
                        <p class="font-thai-1 mt-1 mb-1">
                            <i class="fa fa-window-close-o mr-2" aria-hidden="true"></i>
                            <!-- สามารถเลือกลงคะแนนได้สูงสุด <span class="text-danger">{{ maxVote }}</span> หมายเลข / <span class="text-danger">Maximum Vote {{ maxVote }} Numbers</span> -->
                            สามารถทำเครื่องหมายเพียง <span class="text-danger">{{ maxVote }}</span> ช่องเท่านั้น / Please select only <span class="text-danger">{{ maxVote }}</span> option.
                        </p>
                        <p v-if="maxVote > 1" class="font-thai-1 mt-1 mb-1">กำลังเลือก <span class="text-success">{{ selected.length }}</span> หมายเลข</p>
                    </div>
                    <div v-if="successVote">
                        <b-alert class="text-dark mt-3" variant="success" show>
                            <h4 class="mt-1 mb-0 font-thai-1">You have finished. / คุณได้ทำการลงคะแนนเรียบร้อยเเล้ว</h4>
                        </b-alert>
                        <hr>
                        <b-button :href="$keycloak.createLogoutUrl()" block class="mt-3 mb-2 font-thai" variant="danger"> LogOut </b-button>
                    </div>
                    <div v-else>
                        <div v-if="loadIng">
                            <div class="font-thai text-center mt-3">
                                <b-spinner class="align-middle mr-2"></b-spinner>
                                Checking your eligibility กำลังตรวจสอบสิทธิ์ของท่าน...
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="conditionH">
                                <b-table 
                                    ref="selectableTable"
                                    selectable
                                    :select-mode="maxVote > 1 ? 'multi' : 'single'"
                                    :items="itemDataVote"
                                    :fields="fields" 
                                    @row-selected="onRowSelected"
                                    responsive="sm"
                                    head-variant="dark"
                                    small show-empty bordered striped
                                    class="mt-3"
                                >
                                    <template v-slot:cell(Choose)="row">
                                        <!-- {{ row.index }} -->
                                        <div class="text-center">
                                            <template v-if="row.rowSelected">
                                                <span class="font-thai mr-3" aria-hidden="true"><i class="fa fa-window-close-o fa-3x" aria-hidden="true"></i></span>
                                                <span class="sr-only">Selected</span>
                                            </template>
                                            <template v-else>
                                                <span class="mr-3"><i class="fa fa-square-o fa-3x" aria-hidden="true"></i></span>
                                                <span class="sr-only">Not selected</span>
                                            </template>
                                        </div>
                                    </template>
                                    <!-- {{ row.item.choice_type !== 'single' ? row.item.Numvote : '' }} -->
                                    <!--  
                                        <template v-slot:cell(Numvote)="row">
                                            {{ row.item.Numvote }}
                                        </template>
                                    -->
                                    <template v-slot:cell(Teams)="row">
                                        <b-media>
                                            <!-- <template v-slot:aside> -->
                                                <!-- <b-img blank blank-color="#ccc" width="64" alt="placeholder"></b-img> -->
                                            <!-- </template> -->
                                            <!-- <h5 class="mt-0 mb-0 font-thai-team">{{ row.item.Teams }}</h5> -->
                                            <!-- <p class="mb-0 font-thai-teamdetail"></p> -->
                                            <!-- <pre>{{ row.item.idRow }}</pre> -->
                                            <b-img v-if="row.item.imgPh" thumbnail :src="row.item.imgPh" style="width:64px;height:64px;" alt="loading"></b-img>
                                            <b-img v-else thumbnail blank blank-color="#ccc" width="64" alt="placeholder"></b-img>
                                        </b-media>
                                    </template>
                                    <template v-slot:cell(Detail)="row">
                                        <h5 class="mt-0 mb-1 font-thai-team">{{ row.item.Teams }}</h5>
                                        <span class="font-thai-team" v-html="row.item.detail"></span>
                                    </template>
                                    <template v-slot:cell(toggleUi)="row">
                                        <!-- {{ row.index }} -->
                                        <div class="text-center">
                                            <template v-if="row.rowSelected">
                                                <i class="fa fa-trash fa-lg text-danger"></i>
                                            </template>
                                            <template v-else></template>
                                        </div>
                                    </template>
                                </b-table>
                                <br>
                                <span class="font-thai text-danger" v-html="alertMsg"></span> 
                                <b-button :disabled="selected.length == 0" @click="conFirmVote" block class="mt-3 mb-2 font-thai" variant="success"> Submit </b-button>
                                <hr>
                                <b-button size="sm" :disabled="selected.length == 0" @click="clearVote" block class="mt-3 mb-5 font-thai" variant="warning"><i class="fa fa-refresh mr-2"></i>Clear all</b-button>
                                <br>
                            </div>
                            <div v-else class="mb-3">
                                <!-- 
                                    <b-alert class="text-dark mt-3" variant="danger" show>
                                        <h4 class="mt-1 mb-0 font-thai-1">You cannot vote because</h4>
                                        <hr class="bg-dark">
                                        <p class="mt-1 mb-0 font-thai-1"><i class="fa fa-caret-right mr-1" aria-hidden="true"></i>Your account is not eligible for this election. Sorry for the inconvenience.</p>
                                        <p class="mt-1 mb-0 font-thai-1"><i class="fa fa-caret-right mr-1" aria-hidden="true"></i>Now is not an election period.</p>
                                        <p class="mt-1 mb-0 font-thai-1"><i class="fa fa-caret-right mr-1" aria-hidden="true"></i>You have voted.</p>
                                    </b-alert>
                                    <b-alert class="text-dark mt-2" variant="danger" show>
                                        <h4 class="mt-1 mb-0 font-thai-1">ท่านไม่สามารถทำการลงคะแนนได้เนื่องจาก</h4>
                                        <hr class="bg-dark">
                                        <p class="mt-1 mb-0 font-thai-1"><i class="fa fa-caret-right mr-1" aria-hidden="true"></i>ขออภัย บัญชีของท่าน ไม่สามารถใช้สิทธิลงคะแนนเลือกตั้งครั้งนี้ได้</p>
                                        <p class="mt-1 mb-0 font-thai-1"><i class="fa fa-caret-right mr-1" aria-hidden="true"></i>ขณะนี้ มิใช่ระยะเวลาเลือกตั้ง</p>
                                        <p class="mt-1 mb-0 font-thai-1"><i class="fa fa-caret-right mr-1" aria-hidden="true"></i>คุณได้ทำการลงคะแนนเรียบร้อยเเล้ว</p>
                                    </b-alert> 
                                -->
                                <!-- <h5 class="font-thai-note text-danger"></h5> -->
                                <p class="font-thai-1" v-html="msgContactError"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- content -->
        <!-- modal consent -->
            <b-modal centered ref="bv-modal-voteConsent" id="bv-modal-voteConsent" hide-footer hide-header-close no-close-on-backdrop>
                <template v-slot:modal-title>
                    <!-- <h5 class="font-en font-en-chk font-weight-bold mt-2 mb-0">Are you sure vote</h5> -->
                    <h5 class="font-conf font-weight-bold mt-2 mb-0">ยืนยันการลงคะแนน / Confirmation</h5>
                </template>
                <b-alert show variant="success">
                    <!-- <h4 class="font-en mt-2 mb-2">You are selecting {{ selected.length }} of {{ maxVote }} quota</h4> -->
                    <!-- {{ nOvote.length }} -->
                    <h4 v-if="nOvote.length == 0" class="font-conf mt-2 mb-1">คุณได้ทำการเลือก {{ selected.length }} หมายเลข</h4>
                    <h4 v-if="nOvote.length == 0" class="font-conf mt-2 mb-1">You voted for {{ selected.length }} number(s)</h4>
                    <h6 v-if="nOvote.length == 0" class="font-conf mt-2 mb-2">( สามารถเลือกได้สูงสุด {{ maxVote }} หมายเลข / Maximum Vote : {{ maxVote }} Numbers )</h6>
                    <hr>
                    <!-- 
                        <h3 class="text-danger font-en mt-2 mb-2">
                            <pre>{{ selected }}</pre>
                        </h3> 
                    -->
                    <div v-for="(Condata, index) in selected" :key="index">
                        <b-media class="mt-3">
                            <template v-slot:aside>
                                <b-img v-if="Condata.imgPh" thumbnail :src="Condata.imgPh" style="width:64px;height:64px;" alt="loading"></b-img>
                                <b-img v-else thumbnail blank blank-color="#ccc" width="64" alt="placeholder"></b-img>
                            </template>
                            <h5 class="mt-0 mb-0 font-thai-team">{{ Condata.Teams }}</h5>
                            <p class="mb-0 font-thai-teamdetail">
                                <span v-html="Condata.detail"></span>
                            </p>
                        </b-media>
                    </div>
                </b-alert>
                <!-- <h5 class="font-en mt-3 mb-2">Are you sure you want to select this Candidate ?</h5> -->
                <h5 class="font-conf mt-3 mb-1">หากทำการกดยืนยันแล้วจะไม่สามารถลงคะแนน หรือแก้ไขได้อีกในภายหลัง ( 1 User ต่อ 1 สิทธิ์ลงคะแนน )</h5>
                <h5 class="font-conf mt-0 mb-2">Please note: If your submission has been sent, it is no longer editable.</h5>
                <!-- error msg -->
                <b-alert v-for="msg in errorMsgs" :key="msg.timestamp" show variant="danger" dismissible>
                    <b>{{ msg.msgstatus }} {{ msg.msgstatusText }}</b><br>
                    <span class="mb-0 d-inline-block text-truncate" style="max-width: 320px;">
                        {{ msg.msg }}
                    </span>
                </b-alert>
                <b-button @click="SendVote" class="font-thai" block variant="success">
                    <i class="fa fa-check mr-1" aria-hidden="true"></i>Confirm submit
                </b-button>
                <b-button class="mt-2 mb-2 font-thai" @click="closeModal" block variant="danger"><i class="fa fa-times mr-1" aria-hidden="true"></i>Cancel</b-button>
            </b-modal>
        <!-- modal consent -->
    </div>
</template>

<style lang="scss" scoped>
    .font-conf{ font-family: 'Kanit', sans-serif; }
    .font-thai-1{ font-family: 'Kanit', sans-serif; font-weight: 300; }
    .font-thai{ font-family: 'Kanit', sans-serif; font-weight: 100; font-size: 0.8rem; }
    .font-en{ font-family: 'Rubik', sans-serif; }
    .font-thai-note{ font-family: 'Kanit', sans-serif; font-weight: 300; }
    .font-thai-team{ font-family: 'Kanit', sans-serif; font-weight: 300; }
    .font-thai-teamdetail{ font-family: 'Kanit', sans-serif; font-weight: 100; font-size: 0.8rem; }
    .navbar .navbar-brand {
        margin: 5px 0px;
        padding: 10px 15px;
        font-size: 14px;
        color: #66615B;
    }
    .list-group-item {
        position: relative;
        display: block;
        padding: 0.75rem 1.25rem;
        /* background-color: #fff; */
        border: 1px solid rgba(0, 0, 0, 0.125);
    }
    .bg-image {
        // background-position: center;
        // background-repeat: no-repeat;
        // background-size: cover;
        // background-image: url("../../assets/img/bg-election.png");
    }
    .alert-success {
        background-color: #a9ffd8;
        color: #229863;
    }
    .alert-danger {
        background-color: #fb17173b;
        color: #B33C12;
    }
    .w-5{ width: 5%; }
</style>

<script>
    import { mapGetters, mapActions } from 'vuex'
    const confirmVoteData = {
        no : '',
        name : '',
        position : '',
        work : '',
        vision : '',
    }
    export default {
        data() {
            return {
                currentTime:null,
                timeVote:false,
                arrUserNotVote:false,
                output:'',
                HistoryVote:true,
                confirmVote:false,
                htmlData: Object.assign({}, confirmVoteData),
                wordChk:'',
                // table config
                    successVote: false,
                    nameEvent:'',
                    alertMsg:'',
                    alertMsgDetail:'',
                    startDate:'',
                    endDate:'',
                    errorMsgs: [],
                    maxVote: '',
                    loadIng:false,
                    eventId:null,
                    chkvote: [],
                    nOvote: [],
                    conditionH:false,
                    fields: [ 
                        { 
                            key: 'Choose',
                            // label: 'ช่องลงคะแนน / Vote',
                            label: 'ช่องลงมติ / Vote',
                            class: 'font-weight-bold text-center w-5', 
                            thStyle: 
                            { 
                                fontFamily: 'Kanit',
                                width:'20%',
                            }
                        },
                        // { 
                        //     key: 'Numvote',
                        //     label: 'หมายเลข / No.',
                        //     class: 'font-weight-bold text-center w-5',
                        //     thStyle: 
                        //     { 
                        //         fontFamily: 'Kanit',
                        //         width:'15%',
                        //     } 
                        // },
                        { 
                            key: 'Detail',
                            // label: 'Detail',
                            label: 'Detail / รายละเอียดการลงมติ',
                            class: 'font-weight-bold w-20',
                            thStyle: 
                            { 
                                fontFamily: 'Kanit',
                            } 
                        },
                        { 
                            key: 'Teams',
                            // ผู้สมัคร / Candidates
                            label: '',
                            class: 'font-weight-bold w-20 text-center',
                            thStyle: 
                            { 
                                fontFamily: 'Kanit',
                            } 
                        },
                        { 
                            key: 'toggleUi',
                            label: '',
                            class: 'font-weight-bold text-center w-5',
                            thStyle: 
                            { 
                                width:'5%',
                            }
                        },
                    ],
                    voteValue: null,
                    itemDataVote:[],
                    selected: [],
                    msgContactError: null
                // table config
            }
        },
        computed: {
            ...mapGetters({
                msg: 'getRules'
            }),
            getTokenUrl(){
                return typeof(this.$route.query.token) === "undefined" || this.$route.query.token === "" ?  this.$router.push("/notfound").catch(err => {}) : this.$route.query.token
            },
        },
        created(){
            this.currentTime = this.moment().locale('th').format('LTS');
            setInterval(() => this.updateCurrentTime(), 1 * 1000);
        },
        mounted(){
            this.checkPermit()
        },
        methods: {
            updateCurrentTime() {
                this.currentTime = this.moment().locale('th').format('LTS');
            },
            // table config
                onRowSelected(items) {
                    this.nOvote = []
                    for (let c = 0; c < items.length; c++) {
                        // console.log(items[c].choice_type)
                        if(items[c].choice_type === "single"){
                            this.nOvote.push(items[c].idTeam)
                        }
                    }
                    // console.log(this.nOvote)
                    if(this.nOvote.length != 0){
                        // this.$refs.selectableTable.clearSelected()
                        // this.$refs.selectableTable.selectRow(this.itemDataVote.length-1)
                        for (let k = 0; k < items.length; k++) {
                            // console.log(items[k].idRow+' '+this.nOvote.includes(items[k].idRow))
                            if(!this.nOvote.includes(items[k].idTeam)){
                                // console.log(items[b].idTeam)
                                this.$refs.selectableTable.unselectRow(items[k].idRow)
                                this.chkvote = []
                            }
                        }
                    }else{
                        // console.log('-----'+items.length)
                        if (items.length <= this.maxVote) {
                            this.chkvote = []
                            for (let a = 0; a < this.selected.length; a++) {
                                this.chkvote.push(this.selected[a].idTeam)
                            }
                        }else{
                            for (let b = 0; b < items.length; b++) {
                                // console.log(items[b].idTeam+'---'+this.chkvote.includes(items[b].idTeam))
                                if(!this.chkvote.includes(items[b].idTeam)){
                                    // console.log(items[b].idTeam)
                                    this.$refs.selectableTable.unselectRow(items[b].idRow)
                                }
                            }
                        }
                    }
                    this.selected = items
                },
            // table config
            checkMsgWhoAmi(ValueChk){
                return this.msg.roles.includes(ValueChk)
            },
            async checkPermit(){
                this.loadIng = true
                this.itemDataVote = []
                try {
                    const res = await this.$http.get(`/election/check/?token=${this.getTokenUrl}`)
                    if(res.status === 200){
                        // event name
                        this.nameEvent = res.data.election_name
                        this.alertMsgDetail = res.data.detail_msg
                        this.alertMsg = res.data.subfix_msg
                        // event date
                        this.startDate = this.moment(res.data.start_date).locale('th').format('LLL')
                        this.endDate = this.moment(res.data.end_date).locale('th').format('LLL')
                        // event id
                        this.eventId = res.data.id
                        // event quota select
                        this.maxVote = res.data.max_quota
                        for (let index = 0; index < res.data.choice_data.length; index++) {
                            this.itemDataVote.push(
                                {
                                    'idRow':index,
                                    'Choose': '',
                                    'imgPh': this.photo(res.data.choice_data[index].img_data),
                                    'detail': res.data.choice_data[index].detail,
                                    'Teams': res.data.choice_data[index].name, 
                                    'idTeam': res.data.choice_data[index].id,
                                    'choice_type': res.data.choice_data[index].choice_type,
                                    'Numvote': res.data.choice_data[index].view_order,
                                }
                            )
                        }
                        // this.itemDataVote.sort((a, b) =>{ return b.idTeam - a.idTeam; });
                        this.loadIng = false
                        this.conditionH = true
                    }
                    else{
                        throw { res }
                    }
                } catch (error) {
                    this.loadIng = false
                    this.conditionH = false
                    this.msgContactError = error.response.data.error_subfix_msg
                }
            },
            photo(val) {
                if (val) {
                    return `data:image/jpg;base64,${val}`
                }else{
                    return ''
                }
            },
            clearVote(){
                this.$refs.selectableTable.clearSelected()
            },
            conFirmVote(){
                this.errorMsgs = []
                this.$refs['bv-modal-voteConsent'].show() 
            },
            closeModal(){
                this.$refs['bv-modal-voteConsent'].hide() 
            },
            async SendVote(){
                const sendVote = new FormData();
                sendVote.append("election_event", this.eventId);
                sendVote.append("token", this.getTokenUrl);
                for (let dataVote = 0; dataVote < this.selected.length; dataVote++) {
                    sendVote.append("answer", this.selected[dataVote].idTeam);
                    // console.log(this.selected[dataVote].idTeam)
                }
                try {
                    const saveAnswer = await this.$http.post('/election/voting/',
                        sendVote
                        ,{
                            headers: { 'Content-Type': 'multipart/form-data' }
                        }
                    )
                    if(saveAnswer.status === 200){
                        this.closeModal()
                        this.successVote = true
                        // this.checkPermit()
                    }else{
                        throw { saveAnswer }
                    }
                } catch (error) {
                    this.errorMsgs.push({
                        timestamp: new Date().getTime(),
                        msgstatus: error.response.status,
                        msgstatusText: error.response.statusText,
                        msg: error.response.data,
                    });
                    if (this.errorMsgs.length > 1) this.errorMsgs.shift()
                }
            }
        }
    };
</script>
